import React, { useState, useEffect, useRef } from 'react';
import axios from '../../axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.min.css';
import { TempusDominus } from '@eonasdan/tempus-dominus';

const LogPage = () => {
    const [username, setUsername] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [logType, setLogType] = useState('');
    const [logs, setLogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const logsPerPage = 30;

    const fromDateRef = useRef(null);
    const toDateRef = useRef(null);

    const logTypes = [
        "Đăng nhập hệ thống không thành công sai username",
        "Đăng nhập hệ thống không thành công sai mật khẩu",
        "Đăng nhập hệ thống thành công",
        "Đón tiếp sinh viên"
    ];

    useEffect(() => {
        const fromPicker = new TempusDominus(fromDateRef.current, {
            display: {
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    hours: true,
                    minutes: true,
                    seconds: true
                }
            }
        });

        const toPicker = new TempusDominus(toDateRef.current, {
            display: {
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    hours: true,
                    minutes: true,
                    seconds: true
                }
            }
        });

        fromPicker.subscribe('change', (e) => {
            setFromDate(e.date);
        });

        toPicker.subscribe('change', (e) => {
            setToDate(e.date);
        });
    }, []);

    const handleSearch = async (page = 1) => {
        try {
            const response = await axios.get('/logs', {
                params: {
                    username,
                    fromDate,
                    toDate,
                    logType,
                    page,
                    limit: logsPerPage
                }
            });
            setLogs(response.data.logs);
            setTotalPages(Math.ceil(response.data.totalLogs / logsPerPage));
            setCurrentPage(page);
        } catch (error) {
            console.error('Error fetching logs:', error);
        }
    };

    const handlePageChange = (pageNumber) => {
        handleSearch(pageNumber);
    };

    const truncateText = (text, length) => {
        return text.length > length ? text.substring(0, length) + '...' : text;
    };

    return (
        <div className="container mt-4">
            <h2 className="text-center">Log Viewer</h2>
            <div className="row mb-3">
                <div className="col-md-6">
                    <label htmlFor="username" className="form-label">Username:</label>
                    <input
                        type="text"
                        className="form-control"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label htmlFor="fromDate" className="form-label">From Date:</label>
                    <div className="input-group" ref={fromDateRef}>
                        <input type="text" className="form-control" />
                        <span className="input-group-text" id="basic-addon2">
                            <i className="bi bi-calendar-event"></i>
                        </span>
                    </div>
                </div>
                <div className="col-md-3">
                    <label htmlFor="toDate" className="form-label">To Date:</label>
                    <div className="input-group" ref={toDateRef}>
                        <input type="text" className="form-control" />
                        <span className="input-group-text" id="basic-addon2">
                            <i className="bi bi-calendar-event"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-md-6">
                    <label htmlFor="logType" className="form-label">Log Type:</label>
                    <select
                        className="form-select"
                        id="logType"
                        value={logType}
                        onChange={(e) => setLogType(e.target.value)}
                    >
                        <option value="">Select Log Type</option>
                        {logTypes.map((type, index) => (
                            <option key={index} value={type}>{type}</option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="mb-3">
                <button className="btn btn-primary" onClick={() => handleSearch(1)}>Search Logs</button>
            </div>

            <div className="mt-4">
                <h3>Results:</h3>
                {logs.length > 0 ? (
                    <div>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Username</th>
                                    <th>Action</th>
                                    <th>Timestamp</th>
                                    <th>Details</th>
                                    <th>IP Address</th>
                                    <th>User Agent</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.map((log) => (
                                    <tr key={log._id}>
                                        <td>{log.username}</td>
                                        <td>{log.action}</td>
                                        <td>{new Date(log.timestamp).toLocaleString()}</td>
                                        <td title={log.details}>
                                            {truncateText(log.details, 20)}
                                        </td>
                                        <td>{log.ipAddress}</td>
                                        <td>{log.userAgent}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <nav>
                            <ul className="pagination justify-content-center">
                                {[...Array(totalPages).keys()].map(page => (
                                    <li key={page + 1} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                                            {page + 1}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                ) : (
                    <p className="text-muted">No logs found</p>
                )}
            </div>
        </div>
    );
};

export default LogPage;
